import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import cookies from "js-cookie";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../index.css";
import { useEffect, useState } from "react";

function Avbar() {
  const [darkMode, setDarkMode] = useState(true);
  window.addEventListener("scroll", () => {
    var header = document.getElementById("navbar")
    header.classList.toggle("sticky", window.scrollY > 2)
  })
  const HandleMode = () => {
    if (darkMode === false) {
      setDarkMode(true);
      cookies.set("mode", "true");
    } else {
      setDarkMode(false);
      cookies.set("mode", "false");
    }
  };
  useEffect(() => {
    const body = document.body;
    const toggle = document.querySelector(".toggle-inner");
    if (darkMode === true || cookies.get("mode") === "true") {
      body.classList.add("dark-mode");
      toggle.classList.add("toggle-active");
      toggle.classList.add("sizes-box");
      const paragraphs = document.querySelectorAll("p");
      const t = document.querySelectorAll(".nav-link")

      paragraphs.forEach((p) => {
        p.classList.add("white-text");
      });
      t.forEach((p) => {
        p.classList.add("white-text");
        
      });
      
    } else {
      body.classList.remove("dark-mode");
      toggle.classList.remove("toggle-active");
      toggle.classList.remove("sizes-box");
      const paragraphs = document.querySelectorAll("p");
      paragraphs.forEach((p) => {
        p.classList.remove("white-text");
      });
    }
  }, [darkMode]);

  return (
    <>


      <Navbar collapseOnSelect expand="lg" id="navbar" style={{
        position: "fixed",
        width: "100%",
        zIndex: "1000",
        top: "0",
        left: "0",
        transition: "0.6s",

      }}>
        <Container>
          <Navbar.Brand>
            <Link to="/App" className="nav-link">
              The Avit's Room
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link>
                <Link to="/" className="nav-link">
                  Home
                </Link>
              </Nav.Link>
              <Nav.Link>
                <Link to="/Projects" className="nav-link">
                  My Projects
                </Link>
              </Nav.Link>
              <Nav.Link>
                <Link to="/Resume" className="nav-link">
                  My Resume
                </Link>
              </Nav.Link>
              <Nav.Link>
                <Link to="/Contact" className="nav-link">
                  Contact Me
                </Link>
              </Nav.Link>
              <Nav.Link eventKey={2}>
                <Link to="/About" className="nav-link">
                  About Me
                </Link>
              </Nav.Link>
            </Nav>

          </Navbar.Collapse>
        </Container>
        <div id="toggle" onClick={HandleMode}>
          <div className="toggle-inner" />
        </div>
      </Navbar>
    </>
  );
}

export default Avbar;
